var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_c('b-container',{staticClass:"pt-4 mb-4",attrs:{"fluid":_vm.fluid}},[_c('b-row',[_c('b-col',[(_vm.$wait.is('global loading'))?_c('BlockingContainer'):_vm._e(),_vm._t("default")],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }